import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useState, useEffect } from "react";
import PrivateRoute from "./utility/PrivateRoute";
import Login from "./templates/login";
import Dashboard from "./templates/dashboard";
import SignUp from "./templates/signup";
import Category from "./templates/master/category";
import Mail from "./templates/master/mail";
import SendMail from "./templates/sendmail";
import RelationManager from "./templates/master/relationship_master";
import Subject from "./templates/master/subject";
import Mail_Excel from "./templates/master/mail_excel";
import Lead from "./templates/lead";
import Lead_Excel from "./templates/lead_excel";
import { initAuth } from "./utility/initAuth";

function App() {
  window.addEventListener("error", (e) => {
    if (
      e.message ===
        "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded"
    ) {
      e.stopImmediatePropagation();
    }
  });

  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    async function load() {
      await initAuth(); // 🔥 Fetch a new access token at startup
      setAuthReady(true); // Continue app once token loaded
    }
    load();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="/signup" element={<SignUp />} />
        <Route
          path="/category-master"
          element={
            <PrivateRoute>
              <Category />
            </PrivateRoute>
          }
        />
        <Route
          path="/relationship-master"
          element={
            <PrivateRoute>
              <RelationManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/subject-master"
          element={
            <PrivateRoute>
              <Subject />
            </PrivateRoute>
          }
        />
        {/* <Route
          path="/mail-master"
          element={
            <PrivateRoute>
              <Mail />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/welcome-mail-excel-upload"
          element={
            <PrivateRoute>
              <Mail_Excel />
            </PrivateRoute>
          }
        />
        <Route
          path="/sendmail"
          element={
            <PrivateRoute>
              <SendMail />
            </PrivateRoute>
          }
        />
        {/* <Route
          path="/send-lead-mail"
          element={
            <PrivateRoute>
              <Lead />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/send-lead-mail-excel-upload"
          element={
            <PrivateRoute>
              <Lead_Excel />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
